import './App.css';
import {
    AlertDialog, AlertDialogBody, AlertDialogCloseButton,
    AlertDialogContent, AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    Flex,
    useDisclosure
} from '@chakra-ui/react'
import {useRef, useState} from "react";
import {QrReader} from "react-qr-reader";
import { useToast } from '@chakra-ui/react'
import {getHologramByEncodedId, updateHologramRegistered} from "./FirestoreService";

function App() {

    const [qrRegistrationInitiated, setQrRegistrationInitiated] = useState(false);

    const { isOpen, onOpen, onClose } = useDisclosure()
    const cancelRef = useRef()
    const toast = useToast()

    const [hologramId, setHologramId] = useState(null)

    const [qrRegistrationInProgress, setQrRegistrationInProgress] = useState(false)

    const extractHologramId = (qrText) => {
        const regex = /^lims\.atharvalab\.com\/verify-report\/index\.php\?hologramId=([0-9ABCDEFGHJKMNPQRSTVWXYZ]{5})$/;
        const match = qrText.match(regex);
        return match ? match[1] : null;
    }

    const registerHologramQR = async () => {
        try {
            const hologramContent = await getHologramByEncodedId(hologramId);
            if(hologramContent.data.hologramRegistered) {
                toast({
                    title: 'Hologram Already Registered',
                    description: `Hologram ${hologramId} has already been registered.`,
                    status: 'warning',
                    duration: 5000,
                    isClosable: true,
                })
            }
            else {
                const hologramUpdated = await updateHologramRegistered(hologramContent.id, true);
                if(hologramUpdated) {
                    toast({
                        title: 'Hologram Registered',
                        description: `Hologram ${hologramId} has been successfully registered.`,
                        status: 'success',
                        duration: 5000,
                        isClosable: true,
                    })
                }
            }
        }
        catch (error) {
            toast({
                title: 'Hologram Not Registered',
                description: `Hologram ${hologramId} not registered.`,
                status: 'error',
                duration: 5000,
                isClosable: true,
            })
        }
        resetData();
    }

    const resetData = () => {
        setQrRegistrationInitiated(false);
        onClose();
        setHologramId(null)
        setQrRegistrationInProgress(false)
    }

    return (
        <Flex width="100hh" height="100vh" justifyContent="center" direction="column">
            {
                !qrRegistrationInitiated ?
                    <Button
                        colorScheme="teal" size="lg"
                        marginLeft="20%"
                        marginRight="20%"
                        onClick={() => setQrRegistrationInitiated(!qrRegistrationInitiated)}
                    >
                        Register QR Code
                    </Button>
                    :
                    <QrReader
                        onResult={(result) => {
                            if(!!result && result.text && extractHologramId(result.text)) {
                                console.log(result.text)
                                setHologramId(extractHologramId(result.text))
                                onOpen()
                            }
                        }}
                        style={{ width: '100%', height: '100%' }}
                        constraints={{
                            facingMode: "environment",
                        }}
                        ViewFinder={() => (
                            <>
                                <svg
                                    width="50px"
                                    viewBox="0 0 100 100"
                                    style={{
                                        top: 0,
                                        left: 0,
                                        zIndex: 1,
                                        boxSizing: 'border-box',
                                        border: '50px solid rgba(0, 0, 0, 0.3)',
                                        position: 'absolute',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    <path
                                        fill="none"
                                        d="M13,0 L0,0 L0,13"
                                        stroke="rgba(255, 0, 0, 0.5)"
                                        strokeWidth="5"
                                    />
                                    <path
                                        fill="none"
                                        d="M0,87 L0,100 L13,100"
                                        stroke="rgba(255, 0, 0, 0.5)"
                                        strokeWidth="5"
                                    />
                                    <path
                                        fill="none"
                                        d="M87,100 L100,100 L100,87"
                                        stroke="rgba(255, 0, 0, 0.5)"
                                        strokeWidth="5"
                                    />
                                    <path
                                        fill="none"
                                        d="M100,13 L100,0 87,0"
                                        stroke="rgba(255, 0, 0, 0.5)"
                                        strokeWidth="5"
                                    />
                                </svg>
                            </>
                        )}
                    />
            }
            <AlertDialog
                motionPreset='slideInBottom'
                leastDestructiveRef={cancelRef}
                onClose={onClose}
                isOpen={isOpen}
                isCentered
            >
                <AlertDialogOverlay />

                <AlertDialogContent>
                    <AlertDialogHeader>Register QR {hologramId}</AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>
                        Do you want to register QR {hologramId}?
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button isDisabled={qrRegistrationInProgress} ref={cancelRef} onClick={onClose}>
                            No
                        </Button>
                        <Button
                            isLoading={qrRegistrationInProgress}
                            loadingText={"Registering QR Code"}
                            onClick={() => {
                                setQrRegistrationInProgress(true)
                                registerHologramQR();
                            }}
                            colorScheme='green'
                            ml={3}
                        >
                            Yes
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
        </Flex>
    );
}

export default App;
